import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { hslFromString } from 'src/app/utils/color.utils';
import { DeliveryColorEntry, DeliveryActivityItem } from '../models/delivery-activity.models';
import { DeliveryBlockComponent } from '../delivery-block/delivery-block.component';

@Component({
  selector: 'delivery-block-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './delivery-block-cell.component.html',
  styleUrls: ['./delivery-block-cell.component.scss'],
  imports: [DeliveryBlockComponent],
})
export class DeliveryBlockCellComponent {
  readonly deliveries = input.required<DeliveryActivityItem[]>();
  readonly colorBy = input<'equipment' | 'operator'>('equipment');
  readonly palette = input<DeliveryColorEntry[]>([]);

  readonly deliveryClick = output<DeliveryActivityItem>();

  protected readonly sortedDeliveries = computed(() =>
    [...this.deliveries()].sort((a, b) => a.equipmentLabel.localeCompare(b.equipmentLabel))
  );

  protected readonly deliveryColors = computed(() => {
    const colorBy = this.colorBy();
    const palette = this.palette();
    const result = new Map<string, string>();

    for (const delivery of this.deliveries()) {
      const id = colorBy === 'equipment' ? delivery.equipmentId : delivery.operatorId;
      const label = colorBy === 'equipment' ? delivery.equipmentLabel : delivery.operatorLabel;
      const paletteColor = palette.find(entry => entry.id === id)?.color;
      result.set(delivery.id, paletteColor ?? hslFromString(label));
    }

    return result;
  });

  protected getColor(delivery: DeliveryActivityItem): string {
    return this.deliveryColors().get(delivery.id) ?? hslFromString(delivery.equipmentLabel);
  }
}
